import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Users, MapPin, Receipt } from 'lucide-react';

const ContactsPlacesTabs = ({ activeTab, onTabChange, children }) => {
  const tabs = [
    { id: 'contacts', label: 'Contacts', icon: Users },
    { id: 'places', label: 'Places', icon: MapPin },
    { id: 'reimbursements', label: 'Reimbursements', icon: Receipt },
  ];

  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
      <TabsList className="grid w-full grid-cols-3 mb-6 bg-pink-50/50 p-1 rounded-xl">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <TabsTrigger
              key={tab.id}
              value={tab.id}
              className="flex items-center gap-1.5 data-[state=active]:bg-white data-[state=active]:text-pink-700 data-[state=active]:shadow-sm rounded-lg py-2.5 text-sm font-medium transition-all"
              data-testid={`tab-${tab.id}`}
            >
              <Icon className="h-4 w-4" />
              <span className="hidden sm:inline">{tab.label}</span>
            </TabsTrigger>
          );
        })}
      </TabsList>
      {children}
    </Tabs>
  );
};

export default ContactsPlacesTabs;
